import { useCallback, useState } from 'react';

/**
 * To be used together with ExpandButton
 */
function useExpanded(initialState: boolean) {
  const [isExpanded, setIsExpanded] = useState(initialState);

  const onExpandButtonClick = useCallback(
    () => setIsExpanded(!isExpanded),
    [isExpanded]
  );

  return { isExpanded, onExpandButtonClick };
}

export { useExpanded };
